import type { FaireThemeEntity } from "../../entity_types/theme";

export const everyday_luxe_gold: FaireThemeEntity = {
  token: "everyday-luxe-gold",
  type: "theme",
  name: "Everyday Luxe Gold",
  description: "Hypoallergenic, 18K gold-plated jewelry for daily wear -- non-tarnishing, premium look at accessible price.",
  teaser: "Premium daily-wear gold from the Flanerie by MAIQ collection.",
  detail: "Your San Jose beauty lounge clientele appreciates quality accessories complementing beauty services. Built around your strong interest in the Flanerie by MAIQ collection -- 18K gold-plated, water-resistant pieces.",
  bgColor: "#F0D4C4",
  exactProducts: true,
  retailerToken: "r_v79pcsx8up",
  productTokens: [
    "p_85zuvdfqvw",
    "p_ar6ja253qt",
    "p_pqf2f49nzz",
    "p_dvc55z5255",
    "p_ut3tbs6mrw",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00Z",
    importedBy: "manual-v2-import",
  },
};
